import React from 'react';
import { get, isUndefined } from 'lodash';
import { NumberField, Heading, Text, Label, FlexRow, FlexCol } from 'sarsaparilla';
import { PropTypes } from 'prop-types';

import { DOGS_OR_OTHER_PETS } from 'ui-inyonwhitney/src/utils/inyoUtils';
import { animalTypeToString } from 'ui-permit/src/utils/utils';

const getPetCount = (animals) => {
    const pet = animals.filter((animal) => animal.type === DOGS_OR_OTHER_PETS);
    return pet.length > 0 ? pet[0].amount : 0;
};

export default function PetsQuantity({ animals, animalsLabels = {}, handlePetsChange, maxPets }) {
    const petType = animalTypeToString.get(DOGS_OR_OTHER_PETS);
    const petLabel = get(animalsLabels, petType, petType); // use a label for the form OR the default name
    const petCount = getPetCount(animals);

    const onPetsChange = (amount) => {
        const newAnimals = animals.map((animal) => Object.assign({}, animal));
        for (let i = 0; i < newAnimals?.length; i++) {
            if (newAnimals[i].type === DOGS_OR_OTHER_PETS) {
                newAnimals[i].amount = amount;
                handlePetsChange(newAnimals);
                return;
            }
        }
        // Did not find pet in list
        newAnimals.push({ type: DOGS_OR_OTHER_PETS, amount });
        handlePetsChange(newAnimals);
    };

    return (
        <FlexRow>
            <FlexCol xs={12} className="mb-2">
                <Heading headingLevel={2} appearance="h5">
                    Pets
                </Heading>
                <Text>
                    Please enter the number of pets you will be taking on this trip.
                </Text>
                {!isUndefined(maxPets) &&
                    <Text>
                        Total Pets:
                        <b>{` ${petCount} / ${maxPets}`}</b>
                    </Text>
                }
            </FlexCol>
            <FlexCol xs={7} sm={5} xl={3}>
                <Label htmlFor="pets-type">Type</Label>
                <Text>{petLabel}</Text>
            </FlexCol>
            <FlexCol xs={5} sm={4} xl={2}>
                <Label htmlFor="pets-qty">Quantity</Label>
                <NumberField
                    id="pets-qty"
                    units="pets"
                    min={0}
                    value={petCount}
                    onChange={onPetsChange}
                    max={isUndefined(maxPets) ? 99 : maxPets}
                />
            </FlexCol>
        </FlexRow>
    );
}

PetsQuantity.propTypes = {
    handlePetsChange: PropTypes.func.isRequired,
    animals: PropTypes.array,
    animalsLabels: PropTypes.objectOf(PropTypes.any),
    maxPets: PropTypes.number,
};
PetsQuantity.defaultProps = {
    animals: [],
};
